import * as Dialog from '@positivote/design-system/components/Dialog'

export interface TextDialogProps extends Omit<Dialog.DialogContainerProps, 'title'> {
  /**
   * The dialog title.
   */
  title: { label: string; icon?: React.ReactNode }
  /**
   * The content messages.
   */
  contentTexts: string[]
  /**
   * The accept action.
   */
  acceptAction: { handle: () => void; label: string; icon?: React.ReactNode }
  /**
   * The refuse action.
   */
  refuseAction?: { handle: () => void; label: string; icon?: React.ReactNode }
  /**
   * Content alignment.
   * @default default
   */
  align?: 'center' | 'default'
}

export function TextDialog({
  title,
  contentTexts,
  acceptAction,
  refuseAction,
  onCancel,
  align,
  isLoading,
  ...restProps
}: TextDialogProps): JSX.Element {
  return (
    <Dialog.Container isLoading={isLoading} onCancel={onCancel} {...restProps}>
      <Dialog.Header align={align}>
        {title.icon}
        <Dialog.HeaderTitle align={align}>{title.label}</Dialog.HeaderTitle>
        <Dialog.HeaderCloseButton onCancel={onCancel} isLoading={isLoading} />
      </Dialog.Header>
      <Dialog.Content align={align}>
        {contentTexts.map((contentText, index) => (
          <Dialog.ContentText key={contentText} align={align}>
            {contentText}
          </Dialog.ContentText>
        ))}
      </Dialog.Content>
      <Dialog.Footer align={align}>
        {refuseAction && (
          <Dialog.FooterRefuseButton
            LeadingIcon={refuseAction.icon}
            onClick={refuseAction.handle}
            disabled={isLoading}
          >
            {refuseAction.label}
          </Dialog.FooterRefuseButton>
        )}
        <Dialog.FooterAcceptButton
          LeadingIcon={acceptAction.icon}
          onClick={acceptAction.handle}
          isLoading={isLoading}
        >
          {acceptAction.label}
        </Dialog.FooterAcceptButton>
      </Dialog.Footer>
    </Dialog.Container>
  )
}
